import useSocialShareAccessDeniedStep from './useSocialShareAccessDeniedStep';

export default useSocialShareAccessDeniedStep;
